// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IPageDataCreateTripReviewRequest,
  TPageDataCreateTripReviewModel,
  IMappers,
  TPageDataCreateTripReviewResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IPublicV1PageDataCreateTripReviewResponse } from '../../../entities/response/PublicV1PageDataCreateTripReviewResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createPageDataCreateTripReviewModel(
  parameters: IPageDataCreateTripReviewRequest,
): TPageDataCreateTripReviewModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'dailyrent',
    pathApi: '/v1/page-data/create-trip-review/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IPageDataCreateTripReviewOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPageDataCreateTripReviewRequest;
}

export async function fetchPageDataCreateTripReview<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPageDataCreateTripReviewOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TPageDataCreateTripReviewResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPageDataCreateTripReviewModel(parameters),
    config,
  )) as FetchResponse<TPageDataCreateTripReviewResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicV1PageDataCreateTripReviewResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TPageDataCreateTripReviewResponse>;
}
